/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { Template__TeamIsolatesHost } from '../../templates/team-isolates-host';

@observer
export class Slide13 extends Component {
  componentDidMount() {
    // Do something
  }

  render() {
    const { children } = this.props;
    return (
      <div className={`slide-13`}>
        {children}
        <Template__TeamIsolatesHost />
      </div>
    );
  }
}
